export function sanitizeBrandNameForUrl(brandName: string): string {
  // Convert to lowercase and replace non-alphanumeric with hyphens (matches database slug format)
  return brandName.toLowerCase().trim().replace(/[^a-z0-9]+/g, '-')
}

export function decodeBrandNameFromUrl(urlBrandName: string, allBrands: string[]): string | null {
  // This function is now deprecated - we query the brands table directly by slug
  // Keeping for backwards compatibility
  const sanitizedUrl = urlBrandName.toLowerCase()

  for (const brand of allBrands) {
    const sanitizedBrand = sanitizeBrandNameForUrl(brand).toLowerCase()
    if (sanitizedBrand === sanitizedUrl) {
      return brand
    }
  }

  return null
}